import { DefaultRootState } from 'react-redux';

import { ApplicantInfo, BackofficeLinks } from 'src/models/applicant/resume/backoffice/store';

export const selectApplicantInfo = ({ applicantInfo }: DefaultRootState): ApplicantInfo => applicantInfo;
export const selectBackofficeLinks = ({ resumeViewBackoffice }: DefaultRootState): BackofficeLinks =>
    resumeViewBackoffice;
